import {AbstractModel, JsonObject, JsonProperty} from '../../../../../../core/src/public-api';

@JsonObject('model.PricingSubtotalItem')
export class PricingSubtotalItem extends AbstractModel {
  @JsonProperty(String, 'name')
  name: string;

  @JsonProperty(Number, 'value')
  value: number;
}


@JsonObject('model.PricingSubtotal')
export class PricingSubtotal extends AbstractModel {

  @JsonProperty([PricingSubtotalItem], 'items')
  items: PricingSubtotalItem[];
}


